module.exports = __webpack_public_path__ + "static/media/Holiday.57ff4cd4.svg";